import createStyled from './createStyled.esm.js';

const styled = createStyled();
var styled$1 = styled;

export { styled$1 as default };
